<template>
  <div
    class="cadastrar-form"
    v-if="!cadastroNoticia && !cadastroEncontro"
  >
    <Breadcrumb :items="breadcrumbItems" />
    <div class="titulo-form">
      <h3>{{ isEdicao ? "Editar Atividade" : "Cadastrar Atividade" }}</h3>
    </div>
    <form
      ref="formAtividade"
      @submit.prevent="handleAvancarClick"
    >
      <div class="form-layout">
        <div class="col-left">
          <FormField
            label="Nome"
            id="nome"
            required
            helpText="Informe o nome ou título da atividade"
          >
            <input
              type="text"
              id="nome"
              class="field-input"
              v-model="formData.nome"
              required
            />
          </FormField>

          <FormField
            label="Tipo"
            id="tipo"
            required
            helpText="Selecione o tipo principal da atividade"
          >
            <InputSelect
              :items="tiposSubtipos"
              v-model="formData.tipo_id"
            >
              Selecione um tipo
            </InputSelect>
          </FormField>

          <FormField
            v-if="formData.tipo_id"
            label="Subtipo"
            required
            helpText="Selecione o subtipo específico da atividade"
          >
            <InputSelect
              v-model="formData.subtipo_id"
              :items="subtiposFiltrados"
            >
              Selecione um subtipo
            </InputSelect>
          </FormField>

          <FormField
            label="Modalidade de execução"
            id="modalidade-execucao"
            required
            helpText="Selecione se a atividade será presencial, remota ou híbrida"
          >
            <InputSelect
              :items="campos.modadalidades"
              :campo-alvo="'value'"
              v-model="formData.modalidadeExecucao"
            >
              Selecione uma modalidade
            </InputSelect>
          </FormField>

          <FormField
            label="Modalidade de Inscrição"
            id="modalidade-inscricao"
            required
            helpText="Informe se a atividade necessita de inscrição prévia"
          >
            <InputSelect
              :items="campos.modalidadesInscricao"
              :campo-alvo="'value'"
              v-model="formData.modalidadeInscricao"
            >
              Selecione uma modalidade
            </InputSelect>
          </FormField>

          <div
            v-if="formData.modalidadeInscricao === 'NESCESSITA_INSCRICAO'"
            style="display: flex; flex-direction: column; gap: 16px"
          >
            <div id="datas">
              <FormField
                label="Início Inscrições"
                id="dataInicioInscricao"
                required
                :helpText="
                  isInscricoesIniciadas
                    ? 'Inscrições em andamento. A data de início não pode ser alterada.'
                    : 'Informe a data e horário de início das inscrições'
                "
              >
                <input
                  type="datetime-local"
                  id="dataInicioInscricao"
                  class="field-input"
                  :class="{
                    'field-error':
                      tentouAvancar && !isDataInicioInscricaoValida,
                  }"
                  :min="isInscricoesIniciadas ? undefined : dataMinima"
                  :disabled="isInscricoesIniciadas"
                  v-model="formData.dataInicioInscricao"
                  :required="
                    formData.modalidadeInscricao === 'NESCESSITA_INSCRICAO'
                  "
                />
              </FormField>

              <FormField
                label="Fim Inscrições"
                id="dataFimInscricao"
                required
                helpText="Informe a data e horário de término das inscrições"
              >
                <input
                  type="datetime-local"
                  id="dataFimInscricao"
                  class="field-input"
                  :class="{
                    'field-error': tentouAvancar && !isDataFimInscricaoValida,
                  }"
                  v-model="formData.dataFimInscricao"
                  :min="
                    isInscricoesIniciadas
                      ? dataMinima
                      : formData.dataInicioInscricao
                  "
                  :required="
                    formData.modalidadeInscricao === 'NESCESSITA_INSCRICAO'
                  "
                />
              </FormField>
            </div>

            <FormField
              label="Critério de Inscrição"
              id="criterioInscricao"
              required
              helpText="Selecione o critério para preenchimento das vagas"
            >
              <InputSelect
                :items="campos.criteriosInscricao"
                :campo-alvo="'value'"
                v-model="formData.criterioInscricao"
              >
                Selecione um critério
              </InputSelect>
            </FormField>

            <FormField
              v-if="formData.criterioInscricao === 'CRITERIODACOORDENACAO'"
              label="Link do formulário (Opcional)"
              id="linkFormulario"
              helpText="Informe o link do formulário de inscrição, caso haja"
            >
              <input
                type="url"
                id="linkFormulario"
                class="field-input"
                v-model="formData.linkFormulario"
                placeholder="Sem link"
              />
            </FormField>

            <FormField
              label="Número de vagas"
              id="numeroDeVagasOfertadas"
              helpText="Informe a quantidade de vagas disponíveis ou selecione Ilimitado"
            >
              <input
                type="number"
                id="numeroDeVagasOfertadas"
                class="field-input"
                :value="vagasIlimitadas ? '' : formData.numeroDeVagasOfertadas"
                @input="handleVagasInput"
                min="0"
                :placeholder="
                  vagasIlimitadas ? 'Ilimitado' : 'Informe o número de vagas'
                "
                :disabled="vagasIlimitadas"
              />

              <div class="checkbox-ilimitado">
                <input
                  type="checkbox"
                  id="checkVagasIlimitadas"
                  class="form-check-input"
                  v-model="vagasIlimitadas"
                />
                <label
                  for="checkVagasIlimitadas"
                  class="form-check-label"
                >
                  Ilimitado
                </label>
              </div>
            </FormField>
          </div>

          <AtividadeObjetivosInput
            :acaoId="props.acaoId"
            v-model:objetivos-escolhidos="formData.objetivos"
            v-model:usar-objetivo-geral="usarObjetivoGeral"
            :tentouAvancar="tentouAvancar"
          />

          <FormField
            label="Local"
            id="localLabel"
            required
            helpText="Informe o nome ou identificação do local onde ocorrerá a atividade"
          >
            <input
              type="text"
              id="localLabel"
              class="field-input"
              v-model="formData.localLabel"
              maxlength="256"
              placeholder="Ex: UFC russas - sala 2, Auditório 1, etc..."
              required
            />
          </FormField>

          <LocalizacaoInput
            v-model:local="formData.local"
            @localizacao-selecionada="adicionarLocal"
            :latitude="formData.latitude"
            :longitude="formData.longitude"
          />
        </div>

        <div class="col-right">
          <EditorTextoInput
            v-model="formData.descricao"
            label="Descrição"
            id="descricao"
            required
            helpText="Descreva os objetivos, o conteúdo e a dinâmica da atividade"
            :rows="12"
            :error-message="
              tentouAvancar &&
              !extrairTextoHtml(formData.descricao || '').trim()
                ? 'A descrição da atividade é obrigatória'
                : ''
            "
          />

          <ImagemInput
            :imagem="formData.imagem"
            @enviar-imagem="processImage"
            v-model="formData.imagem.descricaoImagem"
          />

          <PalavrasChaveInput v-model="formData.palavrasChave" />

          <div
            class="field-checkbox"
            style="margin-top: 18px"
            v-if="!isEdicao"
          >
            <input
              type="checkbox"
              id="possuiEncontros"
              v-model="formData.possuiEncontros"
            />
            <label
              class="field-label"
              for="possuiEncontros"
              style="font-weight: 600; cursor: pointer"
            >
              Adicionar encontros a esta atividade
              <span
                class="help-icon"
                title="Marque caso a atividade seja dividida em múltiplos encontros"
                >?</span
              >
            </label>
          </div>

          <div
            v-if="!formData.possuiEncontros"
            class="periodo-realizacao-container"
          >
            <div id="datas">
              <FormField
                label="Início da Atividade"
                id="dataInicioRealizacao"
                required
                helpText="Informe a data e horário de início da atividade"
              >
                <input
                  type="datetime-local"
                  id="dataInicioRealizacao"
                  class="field-input"
                  :class="{
                    'field-error':
                      tentouAvancar && !isDataInicioRealizacaoValida,
                  }"
                  v-model="formData.dataInicioRealizacao"
                  :min="dataMinimaRealizacao"
                  :required="!formData.possuiEncontros"
                />
              </FormField>

              <FormField
                label="Fim da Atividade"
                id="dataFimRealizacao"
                required
                helpText="Informe a data e horário de término da atividade"
              >
                <input
                  type="datetime-local"
                  id="dataFimRealizacao"
                  class="field-input"
                  :class="{
                    'field-error': tentouAvancar && !isDataFimRealizacaoValida,
                  }"
                  v-model="formData.dataFimRealizacao"
                  :min="formData.dataInicioRealizacao || dataMinimaRealizacao"
                  :required="!formData.possuiEncontros"
                />
              </FormField>
            </div>
          </div>

          <div v-if="!isEdicao && isCoordenadorAcao">
            <div class="field-checkbox">
              <input
                type="checkbox"
                value="true"
                id="cadastroNoticia"
                v-model="formData.criarNoticia"
              />
              <label
                class="field-label"
                for="cadastroNoticia"
              >
                Cadastrar noticia automática?
                <span
                  class="help-icon"
                  title="Marque para cadastrar uma notícia automaticamente no portal"
                  >?</span
                >
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="cadastro-form-container">
        <button
          v-if="isEdicao"
          type="button"
          class="restaurar-btn"
          @click="restaurarDadosOriginais"
          :disabled="isLoadingAtividade || isSaving"
        >
          Restaurar dados originais
        </button>

        <template v-if="isEdicao">
          <button
            v-if="formData.possuiEncontros"
            type="submit"
            class="avancar-btn"
            :disabled="isLoadingAtividade || isSaving"
          >
            Editar encontros
          </button>

          <button
            type="button"
            class="confirmar-btn"
            :disabled="isLoadingAtividade || isSaving"
            @click="confirmarEdicao"
          >
            {{ isSaving ? "Salvando..." : "Confirmar edição" }}
          </button>
        </template>

        <template v-else>
          <button
            v-if="!formData.possuiEncontros"
            type="button"
            class="confirmar-btn"
            :disabled="isLoadingAtividade || isSaving"
            @click="cadastrarDireto"
          >
            {{
              isSaving
                ? "Cadastrando..."
                : formData.criarNoticia
                  ? "Cadastrar Notícia"
                  : "Cadastrar Atividade"
            }}
          </button>

          <template v-else>
            <button
              type="submit"
              class="confirmar-btn"
              :disabled="isLoadingAtividade || isSaving"
            >
              Cadastrar Encontros
            </button>
          </template>
        </template>
      </div>
    </form>
  </div>
  <Aviso
    v-if="aviso.mostrar"
    :sucesso="aviso.sucesso"
    :texto="aviso.mensagem"
    @fecharModal="aviso.mostrar = false"
  />
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import Breadcrumb from "@/components/common/Breadcrumb.vue";
import FormField from "@/components/common/FormField.vue";
import InputSelect from "../common/InputSelect.vue";
import ImagemInput from "../common/imagemInput.vue";
import PalavrasChaveInput from "../common/PalavrasChaveInput.vue";
import AtividadeObjetivosInput from "./AtividadeObjetivosInput.vue";
import EditorTextoInput from "@/components/common/EditorTextoInput.vue";
import Aviso from "@/components/common/aviso.vue";
import acaoService from "@/service/acaoService";

import { useAtividades } from "@/composables/useAtividades.js";
import { useValidacaoAtividade } from "@/composables/useValidacaoAtividade";
import {
  formatarParaInputDateTimeLocal,
  getDataHoraLocal,
  extrairTextoHtml,
} from "@/utils/FormatarEntradas";
import LocalizacaoInput from "../common/LocalizacaoInput.vue";
import {
  setCadastroAtividadeTemp,
  getCadastroAtividadeTemp,
  clearCadastroAtividadeTemp,
  setAtividadeEmCadastro,
  clearAtividadeEmCadastro,
} from "@/utils/atividadeCadastroStorage";

dayjs.extend(utc);
dayjs.extend(timezone);

const toUTC = (date) => {
  if (!date) return null;
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};

const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
  atividadeId: {
    type: String,
    default: "",
  },
});

const router = useRouter();
const route = useRoute();
const formAtividade = ref(null);
const {
  tiposSubtipos,
  fetchTiposeSubtipos,
  fetchAtividadeById,
  saveAtividade,
  updateAtividade,
  isLoading: isLoadingAtividade,
  isSaving,
} = useAtividades();

const {
  criarAtividadePadrao,
  validarObjetivosEPalavrasChave: checkObjetivosEPalavrasChave,
  validarPeriodoRealizacao,
  validarPeriodoInscricao,
  validarDescricaoImagem,
  verificarDataInicioInscricaoValida,
  verificarDataFimInscricaoValida,
  verificarDataInicioRealizacaoValida,
  verificarDataFimRealizacaoValida,
  calcularDataMinimaRealizacao,
} = useValidacaoAtividade();

const targetAtividadeId = computed(
  () => props.atividadeId || route.params.atividadeId || ""
);
const isEdicao = computed(() => Boolean(targetAtividadeId.value));

const formData = ref({
  ...criarAtividadePadrao(props.acaoId),
  latitude: null,
  longitude: null,
});

const campos = ref({
  modadalidades: [
    { value: "REMOTA", nome: "Remota" },
    { value: "PRESENCIAL", nome: "Presencial" },
    { value: "HIBRIDA", nome: "Híbrida" },
  ],
  modalidadesInscricao: [
    { value: "NESCESSITA_INSCRICAO", nome: "Com Inscrição" },
    {
      value: "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA",
      nome: "Sem Inscrição (Com Frequência)",
    },
    {
      value: "NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA",
      nome: "Sem Inscrição (Sem Frequência)",
    },
  ],
  criteriosInscricao: [
    { value: "ORDEMDEINSCRICAO", nome: "Ordem de Inscrição" },
    { value: "CRITERIODACOORDENACAO", nome: "Critério da Coordenação" },
  ],
});

const tentouAvancar = ref(false);
const isCoordenadorAcao = ref(false);

async function checarPermissaoCoordenador() {
  try {
    const targetAcaoId = props.acaoId || route.params.id;
    if (targetAcaoId) {
      isCoordenadorAcao.value =
        await acaoService.verificarCoordenador(targetAcaoId);
    }
  } catch (error) {
    console.error("Erro ao verificar coordenador da ação:", error);
    isCoordenadorAcao.value = false;
  }
}
const dataMinima = ref(getDataHoraLocal());
const usarObjetivoGeral = ref(false);
const vagasIlimitadas = ref(false);

const dataInicioInscricaoOriginal = ref(null);
const statusAtividadeOriginal = ref(null);

const isInscricoesIniciadas = computed(() => {
  if (!isEdicao.value) return false;
  if (formData.value.modalidadeInscricao !== "NESCESSITA_INSCRICAO")
    return false;
  if (
    formData.value.status === "INSCRICOES_ABERTAS" ||
    statusAtividadeOriginal.value === "INSCRICOES_ABERTAS" ||
    formData.value.statusOriginal === "INSCRICOES_ABERTAS"
  ) {
    return true;
  }
  const dataOrig =
    dataInicioInscricaoOriginal.value ||
    formData.value.dataInicioInscricaoOriginal;
  if (dataOrig) {
    const d = new Date(dataOrig).getTime();
    return !isNaN(d) && d <= Date.now();
  }
  return false;
});

const aviso = ref({
  mostrar: false,
  mensagem: "",
  sucesso: false,
});

const breadcrumbItems = computed(() => {
  const targetAcaoId = props.acaoId || route.params.id;
  if (isEdicao.value) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: targetAcaoId, to: `/acao/${targetAcaoId}` },
      { label: "Atividades", to: `/acao/${targetAcaoId}/atividades-acao` },
      {
        label: formData.value.nome || "Atividade",
        to: `/acao/${targetAcaoId}/atividades/${targetAtividadeId.value}`,
      },
      {
        label: "Editar Atividade",
        to: `/acao/${targetAcaoId}/editar-atividade/${targetAtividadeId.value}`,
      },
    ];
  }
  return [
    { label: "Início", to: "/" },
    { label: "Ações", to: "/suas-acoes" },
    { tipo: "acao", id: targetAcaoId, to: `/acao/${targetAcaoId}` },
    { label: "Atividades", to: `/acao/${targetAcaoId}/atividades-acao` },
    {
      label: "Cadastrar Atividade",
      to: `/acao/${targetAcaoId}/cadastrar-atividade`,
    },
  ];
});

const subtiposFiltrados = computed(() => {
  const tipoSelecionado = tiposSubtipos.value.find(
    (t) => t.id === formData.value.tipo_id
  );
  return tipoSelecionado ? tipoSelecionado.subTipos : [];
});

watch(vagasIlimitadas, (isIlimitado) => {
  formData.value.numeroDeVagasOfertadas = isIlimitado ? 0 : null;
});

watch(
  () => formData.value.modalidadeInscricao,
  (valor) => {
    if (valor !== "NESCESSITA_INSCRICAO") {
      formData.value.dataInicioInscricao = "";
      formData.value.dataFimInscricao = "";
      formData.value.criterioInscricao = null;
      formData.value.linkFormulario = "";
      formData.value.numeroDeVagasOfertadas = null;
      vagasIlimitadas.value = false;
    }
  }
);

watch(
  () => formData.value.possuiEncontros,
  (possui) => {
    if (!possui) {
      formData.value.encontros = [];
      const parsed = getCadastroAtividadeTemp();
      if (parsed) {
        parsed.encontros = [];
        setCadastroAtividadeTemp(parsed);
      }
    }
  }
);

watch(tiposSubtipos, (novosTipos) => {
  if (
    formData.value.subtipo_id &&
    !formData.value.tipo_id &&
    novosTipos?.length
  ) {
    const tipo = novosTipos.find((t) =>
      t.subTipos?.some((st) => st.id === formData.value.subtipo_id)
    );
    if (tipo) {
      formData.value.tipo_id = tipo.id;
    }
  }
});

function handleVagasInput(event) {
  const valor = event.target.value;

  if (valor === "" || valor === null) {
    formData.value.numeroDeVagasOfertadas = null;
    return;
  }

  const numero = parseInt(valor, 10);

  if (numero === 0) {
    vagasIlimitadas.value = true;
    formData.value.numeroDeVagasOfertadas = 0;
  } else {
    formData.value.numeroDeVagasOfertadas = isNaN(numero) ? null : numero;
  }
}

function adicionarLocal(local) {
  formData.value.latitude = local.latitude;
  formData.value.longitude = local.longitude;
}

function processImage(imagem) {
  if (!formData.value.imagem) {
    formData.value.imagem = {
      mimeType: "",
      base64Data: "",
      descricaoImagem: "",
    };
  }

  if (imagem) {
    formData.value.imagem.mimeType = imagem.mimeType;
    formData.value.imagem.base64Data = imagem.base64Data;
  } else {
    formData.value.imagem.mimeType = "";
    formData.value.imagem.base64Data = "";
    formData.value.imagem.descricaoImagem = "";
  }
}

function validarObjetivosEPalavrasChave() {
  const resultado = checkObjetivosEPalavrasChave(
    formData.value.objetivos,
    usarObjetivoGeral.value,
    formData.value.palavrasChave
  );
  if (!resultado.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: resultado.mensagem,
    };
    return false;
  }
  return true;
}

const dataMinimaRealizacao = computed(() =>
  calcularDataMinimaRealizacao(
    formData.value.dataFimInscricao,
    dataMinima.value
  )
);

const isDataInicioInscricaoValida = computed(() => {
  if (isInscricoesIniciadas.value) return true;
  return verificarDataInicioInscricaoValida(
    formData.value.modalidadeInscricao,
    formData.value.dataInicioInscricao
  );
});

const isDataFimInscricaoValida = computed(() =>
  verificarDataFimInscricaoValida(
    formData.value.modalidadeInscricao,
    formData.value.dataInicioInscricao,
    formData.value.dataFimInscricao
  )
);

const isDataInicioRealizacaoValida = computed(() =>
  verificarDataInicioRealizacaoValida(
    formData.value.possuiEncontros,
    formData.value.dataInicioRealizacao
  )
);

const isDataFimRealizacaoValida = computed(() =>
  verificarDataFimRealizacaoValida(
    formData.value.possuiEncontros,
    formData.value.dataInicioRealizacao,
    formData.value.dataFimRealizacao
  )
);

function validarGeolocalizacao(latitude, longitude) {
  const temLat = latitude !== null && latitude !== undefined && latitude !== "";
  const temLong =
    longitude !== null && longitude !== undefined && longitude !== "";
  if ((temLat && !temLong) || (!temLat && temLong)) {
    return {
      valido: false,
      mensagem: "Informe latitude e longitude juntos ou deixe ambos em branco.",
    };
  }
  return { valido: true };
}

function limitarDecimaisCoord(campo, event) {
  const input = event.target;
  let val = input.value;
  if (!val) return;
  const sep = val.includes(".") ? "." : val.includes(",") ? "," : null;
  if (sep) {
    const [inteiro, decimal] = val.split(sep);
    if (decimal && decimal.length > 6) {
      const truncado = `${inteiro}${sep}${decimal.slice(0, 6)}`;
      input.value = truncado;
      formData.value[campo] = Number(truncado.replace(",", "."));
    }
  }
}

function handleAvancarClick() {
  tentouAvancar.value = true;

  if (formAtividade.value && !formAtividade.value.reportValidity()) {
    return;
  }

  const validacaoGeo = validarGeolocalizacao(
    formData.value.latitude,
    formData.value.longitude
  );
  if (!validacaoGeo.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoGeo.mensagem,
    };
    return;
  }

  const descricaoPura = extrairTextoHtml(formData.value.descricao || "").trim();
  if (!descricaoPura) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: "Por favor, preencha a descrição da atividade.",
    };
    return;
  }

  if (!validarObjetivosEPalavrasChave()) {
    return;
  }

  const validacaoInscricao = validarPeriodoInscricao(
    formData.value.modalidadeInscricao,
    formData.value.dataInicioInscricao,
    formData.value.dataFimInscricao
  );
  if (!validacaoInscricao.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoInscricao.mensagem,
    };
    return;
  }

  if (
    isInscricoesIniciadas.value &&
    formData.value.dataFimInscricao &&
    dayjs(formData.value.dataFimInscricao).isBefore(dayjs())
  ) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: "A data de término das inscrições não pode ser no passado.",
    };
    return;
  }

  if (!isCoordenadorAcao.value) {
    formData.value.criarNoticia = false;
  }

  if (!formData.value.possuiEncontros) {
    cadastrarDireto();
    return;
  }

  const tipoSelecionado = tiposSubtipos.value.find(
    (t) => t.id === formData.value.tipo_id
  );
  const subtipoSelecionado = tipoSelecionado?.subTipos?.find(
    (st) => st.id === formData.value.subtipo_id
  );

  const latitudeVal =
    formData.value.latitude !== null &&
    formData.value.latitude !== undefined &&
    formData.value.latitude !== ""
      ? Number(Number(formData.value.latitude).toFixed(6))
      : null;
  const longitudeVal =
    formData.value.longitude !== null &&
    formData.value.longitude !== undefined &&
    formData.value.longitude !== ""
      ? Number(Number(formData.value.longitude).toFixed(6))
      : null;

  setCadastroAtividadeTemp({
    ...formData.value,
    latitude: latitudeVal,
    longitude: longitudeVal,
    tipoNome: tipoSelecionado?.nome || tipoSelecionado?.tipo || "",
    subtipoNome:
      subtipoSelecionado?.nome || subtipoSelecionado?.subtipo || "",
    id: targetAtividadeId.value || undefined,
    atividadeId: targetAtividadeId.value || undefined,
  });

  const targetAcaoId = props.acaoId || route.params.id;
  if (isEdicao.value) {
    router.push({
      name: "editar-encontros-atividade",
      params: { id: targetAcaoId, atividadeId: targetAtividadeId.value },
    });
  } else {
    router.push({
      name: "cadastrar-encontros-atividade",
      params: { id: targetAcaoId },
    });
  }
}

async function cadastrarDireto() {
  tentouAvancar.value = true;

  if (formAtividade.value && !formAtividade.value.reportValidity()) {
    return;
  }

  const validacaoGeo = validarGeolocalizacao(
    formData.value.latitude,
    formData.value.longitude
  );
  if (!validacaoGeo.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoGeo.mensagem,
    };
    return;
  }

  const descricaoPura = extrairTextoHtml(formData.value.descricao || "").trim();
  if (!descricaoPura) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: "Por favor, preencha a descrição da atividade.",
    };
    return;
  }

  if (!validarObjetivosEPalavrasChave()) {
    return;
  }

  const validacaoInscricao = validarPeriodoInscricao(
    formData.value.modalidadeInscricao,
    formData.value.dataInicioInscricao,
    formData.value.dataFimInscricao
  );
  if (!validacaoInscricao.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoInscricao.mensagem,
    };
    return;
  }

  if (
    isInscricoesIniciadas.value &&
    formData.value.dataFimInscricao &&
    dayjs(formData.value.dataFimInscricao).isBefore(dayjs())
  ) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: "A data de término das inscrições não pode ser no passado.",
    };
    return;
  }

  const validacaoPeriodo = validarPeriodoRealizacao(
    formData.value.dataInicioRealizacao,
    formData.value.dataFimRealizacao,
    formData.value.possuiEncontros,
    formData.value.dataFimInscricao
  );
  if (!validacaoPeriodo.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoPeriodo.mensagem,
    };
    return;
  }

  // Se o usuário decidiu cadastrar sem encontros, limpa qualquer encontro anterior
  formData.value.encontros = [];

  if (!isCoordenadorAcao.value) {
    formData.value.criarNoticia = false;
  }

  const payload = JSON.parse(JSON.stringify(formData.value));
  payload.encontros = [];
  payload.dataInicioRealizacao = formData.value.dataInicioRealizacao
    ? toUTC(formData.value.dataInicioRealizacao)
    : null;
  payload.dataFimRealizacao = formData.value.dataFimRealizacao
    ? toUTC(formData.value.dataFimRealizacao)
    : null;
  payload.dataInicioInscricao =
    formData.value.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
    formData.value.dataInicioInscricao
      ? toUTC(formData.value.dataInicioInscricao)
      : null;
  payload.dataFimInscricao =
    formData.value.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
    formData.value.dataFimInscricao
      ? toUTC(formData.value.dataFimInscricao)
      : null;
  payload.latitude =
    formData.value.latitude !== null &&
    formData.value.latitude !== undefined &&
    formData.value.latitude !== ""
      ? Number(Number(formData.value.latitude).toFixed(6))
      : null;
  payload.longitude =
    formData.value.longitude !== null &&
    formData.value.longitude !== undefined &&
    formData.value.longitude !== ""
      ? Number(Number(formData.value.longitude).toFixed(6))
      : null;

  const tipoSelecionado = tiposSubtipos.value.find(
    (t) => t.id === formData.value.tipo_id
  );
  const subtipoSelecionado = tipoSelecionado?.subTipos?.find(
    (st) => st.id === formData.value.subtipo_id
  );

  payload.tipoNome = tipoSelecionado?.nome || tipoSelecionado?.tipo || "";
  payload.subtipoNome =
    subtipoSelecionado?.nome || subtipoSelecionado?.subtipo || "";

  // Fallback de imagem da ação pai caso a atividade não tenha imagem própria
  if (!payload.imagem || !payload.imagem.base64Data) {
    try {
      const targetAcaoId = props.acaoId || route.params.id;
      if (targetAcaoId) {
        const dadosAcao = await acaoService.getAcoesById(targetAcaoId);
        if (dadosAcao?.imagem?.base64Data) {
          payload.imagem = {
            mimeType: dadosAcao.imagem.mimeType || "image/png",
            base64Data: dadosAcao.imagem.base64Data,
            descricaoImagem:
              dadosAcao.descricaoImagem ||
              `Imagem da ação ${dadosAcao.titulo || ""}`,
          };
        } else if (dadosAcao?.imagemUrl) {
          payload.imagemUrl = dadosAcao.imagemUrl;
          payload.descricaoImagem =
            dadosAcao.descricaoImagem ||
            `Imagem da ação ${dadosAcao.titulo || ""}`;
          payload.imagem = null;
        } else {
          payload.imagem = null;
        }
      } else {
        payload.imagem = null;
      }
    } catch (e) {
      console.error("Erro ao buscar imagem padrão da ação:", e);
      payload.imagem = null;
    }
  }

  const targetAcaoId = props.acaoId || route.params.id;

  if (payload.criarNoticia) {
    try {
      setAtividadeEmCadastro(payload);
      clearCadastroAtividadeTemp();

      await router.push({
        name: "cadastrar-noticia",
        params: { id: targetAcaoId },
      });
    } catch (error) {
      console.error("Erro ao avançar para cadastro de notícia:", error);
      aviso.value = {
        mostrar: true,
        sucesso: false,
        mensagem:
          "Não foi possível abrir o formulário de cadastro de notícia. Por favor, tente novamente.",
      };
    }
    return;
  }

  try {
    const atividadeSalva = await saveAtividade(payload);
    clearCadastroAtividadeTemp();
    clearAtividadeEmCadastro();

    const finalAtividadeId = atividadeSalva?.id || atividadeSalva?.atividadeId;

    if (targetAcaoId && finalAtividadeId) {
      router.push(`/acao/${targetAcaoId}/atividades/${finalAtividadeId}`);
    } else {
      router.push("/atividades");
    }
  } catch (error) {
    console.error("Erro ao cadastrar atividade diretamente:", error);
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem:
        error?.response?.data?.message ||
        error?.message ||
        "Ocorreu um erro ao cadastrar a atividade. Por favor, tente novamente.",
    };
  }
}

function obterTipoIdPorSubtipoId(subtipoId, listaTipos = []) {
  if (!subtipoId || !listaTipos.length) return "";
  const tipo = listaTipos.find((t) =>
    t.subTipos?.some((st) => st.id === subtipoId)
  );
  return tipo ? tipo.id : "";
}

async function carregarImagemUrlComoBase64(url) {
  if (!url) return { mimeType: "", base64Data: "", descricaoImagem: "" };
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const tiposPermitidos = ["image/jpeg", "image/png"];
    if (!tiposPermitidos.includes(blob.type)) {
      return { mimeType: "", base64Data: "", descricaoImagem: "" };
    }
    const base64Data = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return { mimeType: blob.type, base64Data, descricaoImagem: "" };
  } catch (error) {
    console.warn("Erro ao processar imagem existente:", error);
    return { mimeType: "", base64Data: "", descricaoImagem: "" };
  }
}

function mapearAtividadeParaFormData(dados, imagem, tipoId) {
  const vagas = dados.numeroDeVagasOfertadas;
  vagasIlimitadas.value = !vagas || vagas === 0;

  return {
    id: dados.id,
    nome: dados.nome || "",
    descricao: dados.descricao || "",
    tipo_id: tipoId,
    subtipo_id: dados.subtipoId || "",
    modalidadeExecucao: dados.modalidadeExecucao || "",
    modalidadeInscricao: dados.modalidadeInscricao || "",
    local: dados.local || "",
    localLabel: dados.localLabel || "",
    latitude:
      dados.latitude !== null && dados.latitude !== undefined
        ? Number(Number(dados.latitude).toFixed(6))
        : null,
    longitude:
      dados.longitude !== null && dados.longitude !== undefined
        ? Number(Number(dados.longitude).toFixed(6))
        : null,
    acaoExtensaoId: dados.acaoId || props.acaoId || route.params.id || "",
    dataInicioInscricao: formatarParaInputDateTimeLocal(
      dados.dataInicioInscricao
    ),
    dataFimInscricao: formatarParaInputDateTimeLocal(dados.dataFimInscricao),
    criterioInscricao: dados.criterioInscricao || null,
    numeroDeVagasOfertadas: vagasIlimitadas.value ? null : vagas,
    linkFormulario: dados.linkFormulario || "",
    objetivos: Array.isArray(dados.objetivos)
      ? dados.objetivos.map((o) =>
          typeof o === "object" && o !== null ? o.id : o
        )
      : [],
    encontros: [],
    criarNoticia: false,
    palavrasChave: Array.isArray(dados.palavrasChave)
      ? [...dados.palavrasChave]
      : [],
    possuiEncontros:
      dados.possuiEncontros !== undefined
        ? Boolean(dados.possuiEncontros)
        : true,
    dataInicioRealizacao: formatarParaInputDateTimeLocal(
      dados.dataInicioRealizacao || dados.dataInicio
    ),
    dataFimRealizacao: formatarParaInputDateTimeLocal(
      dados.dataFimRealizacao || dados.dataFim
    ),
    imagem,
    status: dados.status || "",
    dataInicioInscricaoOriginal: dados.dataInicioInscricao || null,
    statusOriginal: dados.status || null,
  };
}

async function carregarDadosAtividade(id) {
  try {
    const dados = await fetchAtividadeById(id);
    if (!dados) return;

    dataInicioInscricaoOriginal.value = dados.dataInicioInscricao || null;
    statusAtividadeOriginal.value = dados.status || null;

    const tipoId = obterTipoIdPorSubtipoId(
      dados.subtipoId,
      tiposSubtipos.value
    );
    const imagem = await carregarImagemUrlComoBase64(dados.imagemUrl);

    formData.value = mapearAtividadeParaFormData(dados, imagem, tipoId);
    setCadastroAtividadeTemp(formData.value);
  } catch (err) {
    console.error("Erro ao carregar dados da atividade:", err);
  }
}

async function restaurarDadosOriginais() {
  if (!targetAtividadeId.value) return;
  try {
    tentouAvancar.value = false;
    usarObjetivoGeral.value = false;
    clearCadastroAtividadeTemp();
    await carregarDadosAtividade(targetAtividadeId.value);
    aviso.value = {
      mostrar: true,
      sucesso: true,
      mensagem: "Dados originais da atividade restaurados com sucesso!",
    };
  } catch (err) {
    console.error("Erro ao restaurar dados da atividade:", err);
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: "Não foi possível restaurar os dados originais.",
    };
  }
}

async function confirmarEdicao() {
  tentouAvancar.value = true;

  if (formAtividade.value && !formAtividade.value.reportValidity()) {
    return;
  }

  const validacaoGeo = validarGeolocalizacao(
    formData.value.latitude,
    formData.value.longitude
  );
  if (!validacaoGeo.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoGeo.mensagem,
    };
    return;
  }

  if (!validarObjetivosEPalavrasChave()) {
    return;
  }

  const validacaoInscricao = validarPeriodoInscricao(
    formData.value.modalidadeInscricao,
    formData.value.dataInicioInscricao,
    formData.value.dataFimInscricao
  );
  if (!validacaoInscricao.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoInscricao.mensagem,
    };
    return;
  }

  if (
    isInscricoesIniciadas.value &&
    formData.value.dataFimInscricao &&
    dayjs(formData.value.dataFimInscricao).isBefore(dayjs())
  ) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: "A data de término das inscrições não pode ser no passado.",
    };
    return;
  }

  const validacaoPeriodo = validarPeriodoRealizacao(
    formData.value.dataInicioRealizacao,
    formData.value.dataFimRealizacao,
    formData.value.possuiEncontros,
    formData.value.dataFimInscricao
  );
  if (!validacaoPeriodo.valido) {
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem: validacaoPeriodo.mensagem,
    };
    return;
  }

  if (!targetAtividadeId.value) return;

  try {
    if (!formData.value.possuiEncontros) {
      formData.value.encontros = [];
    }

    const payload = {
      ...formData.value,
      encontros: [],
      dataInicioRealizacao:
        !formData.value.possuiEncontros && formData.value.dataInicioRealizacao
          ? toUTC(formData.value.dataInicioRealizacao)
          : null,
      dataFimRealizacao:
        !formData.value.possuiEncontros && formData.value.dataFimRealizacao
          ? toUTC(formData.value.dataFimRealizacao)
          : null,
      dataInicioInscricao:
        formData.value.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
        formData.value.dataInicioInscricao
          ? toUTC(formData.value.dataInicioInscricao)
          : null,
      dataFimInscricao:
        formData.value.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
        formData.value.dataFimInscricao
          ? toUTC(formData.value.dataFimInscricao)
          : null,
      id: targetAtividadeId.value,
      atividadeId: targetAtividadeId.value,
    };

    if (isInscricoesIniciadas.value) {
      const dataOrig =
        dataInicioInscricaoOriginal.value ||
        formData.value.dataInicioInscricaoOriginal;
      if (dataOrig) {
        payload.dataInicioInscricao = dataOrig;
      }
    }

    const atividadeSalva = await updateAtividade(
      targetAtividadeId.value,
      payload
    );
    clearCadastroAtividadeTemp();

    const targetAcaoId = props.acaoId || route.params.id;
    const finalAtividadeId = atividadeSalva?.id || targetAtividadeId.value;

    router.push(`/acao/${targetAcaoId}/atividades/${finalAtividadeId}`);
  } catch (error) {
    console.error("Erro ao salvar edição da atividade:", error);
    aviso.value = {
      mostrar: true,
      sucesso: false,
      mensagem:
        "Ocorreu um erro ao atualizar a atividade. Por favor, tente novamente.",
    };
  }
}

const rotasDoFluxo = [
  "cadastrar-atividade",
  "cadastrar-encontros-atividade",
  "editar-atividade",
  "editar-encontros-atividade",
  "cadastrar-noticia",
];

onBeforeRouteLeave((to) => {
  if (!rotasDoFluxo.includes(to.name)) {
    clearCadastroAtividadeTemp();
  }
});

onMounted(async () => {
  await checarPermissaoCoordenador();
  await fetchTiposeSubtipos();

  const parsed = getCadastroAtividadeTemp();
  if (parsed) {
    try {
      const targetAcaoId = props.acaoId || route.params.id;
      const matchAcao =
        !parsed.acaoExtensaoId || parsed.acaoExtensaoId === targetAcaoId;
      const matchAtividade =
        !isEdicao.value ||
        parsed.id === targetAtividadeId.value ||
        parsed.atividadeId === targetAtividadeId.value;

      if (matchAcao && matchAtividade) {
        formData.value = { ...formData.value, ...parsed };
        dataInicioInscricaoOriginal.value =
          parsed.dataInicioInscricaoOriginal || null;
        statusAtividadeOriginal.value = parsed.statusOriginal || null;
        return;
      }
    } catch (e) {
      console.error(
        "Erro ao recuperar dados da atividade do sessionStorage:",
        e
      );
    }
  }

  if (isEdicao.value && targetAtividadeId.value) {
    await carregarDadosAtividade(targetAtividadeId.value);
  }
});
</script>

<style scoped>
.cadastro-form-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 1.5rem;
  width: 100%;
}

.restaurar-btn {
  background-color: var(--branco);
  color: var(--laranja-escuro);
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  white-space: nowrap;
}

.restaurar-btn:hover {
  background-color: var(--laranja-claro);
}

.avancar-btn {
  background-color: var(--roxo-primario);
  height: 43.27px;
  color: var(--branco);
  padding: 8px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  white-space: nowrap;
}

.avancar-btn:hover {
  background-color: var(--roxo-medio);
}

.confirmar-btn {
  background: var(--roxo-primario);
  height: 43.27px;
  color: var(--branco);
  border-radius: 6px;
  padding: 8px 28px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
  white-space: nowrap;
}

.confirmar-btn:hover {
  background: var(--roxo-medio);
}

.restaurar-btn:disabled,
.avancar-btn:disabled,
.confirmar-btn:disabled,
.cadastro-form > button:disabled {
  background-color: var(--cinza-medio) !important;
  color: var(--branco) !important;
  border-color: transparent !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}

.field-input.field-error,
.form-select.field-error,
.field-error {
  border: 2px solid var(--vermelho) !important;
  background-color: var(--vermelho-claro) !important;
}

.checkbox-ilimitado {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.checkbox-ilimitado .form-check-input {
  margin: 0;
  cursor: pointer;
  accent-color: var(--roxo-medio);
  width: 16px;
  height: 16px;
}

.checkbox-ilimitado .form-check-label {
  font-size: 14px;
  color: var(--cinza-escuro);
  cursor: pointer;
  user-select: none;
  font-weight: 500;
}

.btn-cadastrar-direto {
  background-color: var(--branco);
  color: var(--roxo-primario, var(--roxo-medio));
  border: 1.5px solid var(--roxo-claro);
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-cadastrar-direto:hover:not(:disabled) {
  background-color: var(--roxo-superficie);
  border-color: var(--roxo-primario, var(--roxo-medio));
  color: var(--roxo-escuro, var(--roxo-primario));
  transform: translateY(-1px);
}

.btn-cadastrar-direto:disabled {
  background-color: var(--cinza-claro) !important;
  color: var(--cinza-medio) !important;
  border-color: var(--cinza-claro) !important;
  cursor: not-allowed !important;
  opacity: 0.7;
  transform: none !important;
}

.periodo-realizacao-container {
  background: var(--roxo-superficie);
  padding: 16px;
  border-radius: 8px;
  border: 1.5px dashed var(--roxo-superficie);
  margin-top: 12px;
}
</style>
